import { createFileRoute, Outlet } from '@tanstack/react-router'
import z from 'zod'
import { ErrorQueueWidget } from '@/widgets/error-queue-widget'

const searchSchema = z.object({
  'pagination.page': z.number().default(1).optional(),
  'pagination.pageSize': z.number().default(10).optional(),
})

export const Route = createFileRoute('/_auth/administration/monitoring/queue')({
  component: RouteComponent,
  validateSearch: searchSchema,
})

function RouteComponent() {
  return (
    <>
      <ErrorQueueWidget />
      <Outlet />
    </>
  )
}
